import PropTypes from 'prop-types';
import React from 'react';

import IconChevronDown from '../Icons/IconChevronDown';
import './index.scss';

const Select = ({ className, options, placeHolderClassName, ...props }) => {
  const { id, value, onChange, disabled } = props;
  const findOptionByValue = options.find(option => option.value === value);
  let placeholderText = '';
  const placeholderClass = ['select__placeholder'];
  if (placeHolderClassName) placeholderClass.push(placeHolderClassName);
  if (findOptionByValue && findOptionByValue.isPlaceholder) {
    placeholderClass.push('select__placeholder__disabled');
  }

  if (options.length) {
    const selectedOption = findOptionByValue === undefined ? options[0] : findOptionByValue;
    placeholderText = selectedOption.label;
    placeholderClass.push(selectedOption.isPlaceholder ? 'select__placeholder__disabled' : '');
  }

  const renderOptions = options.map(option => {
    const { value: optionValue, label, ...otherProps } = option;
    return <Option key={optionValue} value={optionValue} label={label} {...otherProps} />;
  });

  return (
    <div className="select">
      <select
        className={`select__select ${className}`}
        id={id}
        data-testid={id}
        name={id}
        onChange={onChange}
        {...props}
      >
        {renderOptions}
      </select>
      <div className={placeholderClass.join(' ')}>{placeholderText}</div>
      {!disabled && <IconChevronDown classNames="select__icon" />}
    </div>
  );
};

Select.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  placeHolderClassName: PropTypes.string,
};

Select.defaultProps = {
  id: '',
  className: '',
  disabled: false,
  placeHolderClassName: '',
};

const Option = ({ value, label, isPlaceholder }) => {
  if (isPlaceholder) {
    return (
      <option value={value} disabled hidden>
        {label}
      </option>
    );
  }

  return <option value={value}>{label}</option>;
};
Option.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isPlaceholder: PropTypes.bool,
};

Option.defaultProps = {
  isPlaceholder: false,
};

export default Select;
